import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import {
  //,
  FaInstagram,
  FaYoutube,
  FaArrowUp,
  FaEnvelope,
  FaMobileAlt,
  FaTwitterSquare,
} from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="premium-footer">
      <Container>
        <Row className="gy-5">
          {/* Category */}
          <Col lg={3} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h5>Category</h5>
              <ul>
                <li>
                  <NavLink to="/category/iPhone">iPhone</NavLink>
                </li>
                <li>
                  <NavLink to="/category/Mac">Mac</NavLink>
                </li>
                <li>
                  <NavLink to="/category/MacBook">MacBook</NavLink>
                </li>
                <li>
                  <NavLink to="/category/iPad">iPad</NavLink>
                </li>
                <li>
                  <NavLink to="/category/Watch">Watch</NavLink>
                </li>
                <li>
                  <NavLink to="/category/Accessories">Accessories</NavLink>
                </li>
                <li>
                  <NavLink to="/category/POP Phone">POP Phone</NavLink>
                </li>
              </ul>
            </motion.div>
          </Col>

          {/* Useful Links */}
          <Col lg={3} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h5>Useful Links</h5>
              <ul>
                <li>
                  <NavLink to="/aboutus">About Us</NavLink>
                </li>
                <li>
                  <NavLink to="/contactus">Contact Us</NavLink>
                </li>
                <li>
                  <NavLink to="/blogs">Blogs</NavLink>
                </li>
                <li>
                  <NavLink to="/service">Service Centers</NavLink>
                </li>
                <li>
                  <NavLink to="/care">Care Plan Coverage</NavLink>
                </li>
                <li>
                  <NavLink to="/faqs">FAQs</NavLink>
                </li>
              </ul>
            </motion.div>
          </Col>

          {/* Policies */}
          <Col lg={3} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h5>Policies</h5>
              <ul>
                <li>
                  <NavLink to="/disclaimer">Disclaimer Policy</NavLink>
                </li>
                <li>
                  <NavLink to="/terms">Terms & Conditions</NavLink>
                </li>
                <li>
                  <NavLink to="/refund">Cancellation & Refund</NavLink>
                </li>
                <li>
                  <NavLink to="/shipping">Shipping Policy</NavLink>
                </li>
                <li>
                  <NavLink to="/privacy">Privacy Policy</NavLink>
                </li>
                <li>
                  <NavLink to="/security">Security</NavLink>
                </li>
              </ul>
            </motion.div>
          </Col>

          {/* Contact */}
          <Col lg={3} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              viewport={{ once: true }}
            >
              <h5>Contact Us</h5>

              {/* Call Link */}
              <div className="contact-item">
                <FaMobileAlt />
                <a
                  href="tel:+919999999999"
                  onClick={() => console.log("Calling...")}
                >
                  +91 99999 99999
                </a>
              </div>

              <div className="contact-item">
                <FaEnvelope />
                <a
                  href="mailto:customercare@yourbrand.com"
                  onClick={() => console.log("Opening mail...")}
                >
                  customercare@yourbrand.com
                </a>
              </div>

              {/* Social Icons */}
              <div className="social-icons">
                <motion.a
                  href="https://facebook.com/yourpage"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.15 }}
                >
                  <FaTwitterSquare />
                </motion.a>

                <motion.a
                  href="https://instagram.com/yourpage"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.15 }}
                >
                  <FaInstagram />
                </motion.a>

                <motion.a
                  href="https://youtube.com/yourchannel"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.15 }}
                >
                  <FaYoutube />
                </motion.a>
              </div>
            </motion.div>
          </Col>
        </Row>

        {/* Bottom */}
        <div className="footer-bottom">
          <p>© 2026 YourBrand. All Rights Reserved.</p>

          <motion.div
            className="scroll-top"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <FaArrowUp />
          </motion.div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
